module.exports = __webpack_public_path__ + "img/male.5ba41513.svg";